import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { createCustomerContacts } from '../customers'

export default function useCustomerContactCreate() {
  const queryClient = useQueryClient()

  const { mutate, isLoading } = useMutation(createCustomerContacts, {
    onSuccess: () => {
      queryClient.invalidateQueries('customerContacts')
      notification.success({
        message: 'Sucesso!',
        description: 'Cadastro realizado com sucesso!'
      })
    },
    onError: () => {
      notification.error({
        message: 'Erro',
        description: 'Não foi possível completar o cadastro!'
      })
    }
  })

  return { mutate, isLoading }
}
